module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAATCAYAAABY4MdjAAAAtklEQVQYlW3QMUrEQBSA4S9DCFiL7A0ECy/hTEAQL6CIHkTQzkLwMLJsk9lqlUVh7yBaWlh4gLEwgRj3rx4/D97Pq2JMDe6xj03O3XWNOVq/HKfU7oaRGLgMeJ/IdcApXvGFjDOlFKUUMaZmmKtSiilVjGkHdzjEU87dTY1HpH7pKKV2L4zEwFXAx7akE7zgs0+62Ho9/DN9UoMHHGCVc3dbY4E4SpqFkfiT9DaRz8OXNvjGEuc/G044cbDOGAgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/points.png
// module id = 1020
// module chunks = 0